/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Difference_Toggle_AfterInputs */

const et_difference_toggle_after = /** @type {(inputs: Difference_Toggle_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pärast`)
};

const en_difference_toggle_after = /** @type {(inputs: Difference_Toggle_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After`)
};

/**
* | output |
* | --- |
* | "After" |
*
* @param {Difference_Toggle_AfterInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const difference_toggle_after = /** @type {((inputs?: Difference_Toggle_AfterInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Difference_Toggle_AfterInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_difference_toggle_after(inputs)
	return en_difference_toggle_after(inputs)
});